import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import enCommon from './locales/en/common.json';
import enFeedback from './locales/en/feedback.json';
import enGlossary from './locales/en/glossary.json';
import enFinancialQuestions from './locales/en/financialQuestions.json';
import enBudget from './locales/en/budget.json';
import enNetWorth from './locales/en/netWorth.json';
import enDebtManager from './locales/en/debtManager.json';
import enStatementAnalyzer from './locales/en/statementAnalyzer.json';
import enPortfolioAnalyzer from './locales/en/portfolioAnalyzer.json';
import enCreditAnalyzer from './locales/en/creditAnalyzer.json';
import enLoanPlanning from './locales/en/loanPlanning.json';
import enTaxPlanning from './locales/en/taxPlanning.json';
import enGoals from './locales/en/goals.json';
import enDocuments from './locales/en/documents.json';
import enAiAdvisor from './locales/en/aiAdvisor.json';

import esCommon from './locales/es/common.json';
import esFinancialQuestions from './locales/es/financialQuestions.json';
import esBudget from './locales/es/budget.json';
import esNetWorth from './locales/es/netWorth.json';
import esDebtManager from './locales/es/debtManager.json';
import esStatementAnalyzer from './locales/es/statementAnalyzer.json';
import esPortfolioAnalyzer from './locales/es/portfolioAnalyzer.json';
import esCreditAnalyzer from './locales/es/creditAnalyzer.json';
import esLoanPlanning from './locales/es/loanPlanning.json';
import esTaxPlanning from './locales/es/taxPlanning.json';
import esGoals from './locales/es/goals.json';
import esDocuments from './locales/es/documents.json';
import esAiAdvisor from './locales/es/aiAdvisor.json';

import frCommon from './locales/fr/common.json';
import frFinancialQuestions from './locales/fr/financialQuestions.json';
import frBudget from './locales/fr/budget.json';
import frNetWorth from './locales/fr/netWorth.json';
import frDebtManager from './locales/fr/debtManager.json';
import frStatementAnalyzer from './locales/fr/statementAnalyzer.json';
import frPortfolioAnalyzer from './locales/fr/portfolioAnalyzer.json';
import frCreditAnalyzer from './locales/fr/creditAnalyzer.json';
import frLoanPlanning from './locales/fr/loanPlanning.json';
import frTaxPlanning from './locales/fr/taxPlanning.json';
import frGoals from './locales/fr/goals.json';
import frDocuments from './locales/fr/documents.json';
import frAiAdvisor from './locales/fr/aiAdvisor.json';

import deCommon from './locales/de/common.json';
import deFinancialQuestions from './locales/de/financialQuestions.json';
import deBudget from './locales/de/budget.json';
import deNetWorth from './locales/de/netWorth.json';
import deDebtManager from './locales/de/debtManager.json';
import deStatementAnalyzer from './locales/de/statementAnalyzer.json';
import dePortfolioAnalyzer from './locales/de/portfolioAnalyzer.json';
import deCreditAnalyzer from './locales/de/creditAnalyzer.json';
import deLoanPlanning from './locales/de/loanPlanning.json';
import deTaxPlanning from './locales/de/taxPlanning.json';
import deGoals from './locales/de/goals.json';
import deDocuments from './locales/de/documents.json';
import deAiAdvisor from './locales/de/aiAdvisor.json';

import itCommon from './locales/it/common.json';
import itFinancialQuestions from './locales/it/financialQuestions.json';
import itBudget from './locales/it/budget.json';
import itNetWorth from './locales/it/netWorth.json';
import itDebtManager from './locales/it/debtManager.json';
import itStatementAnalyzer from './locales/it/statementAnalyzer.json';
import itPortfolioAnalyzer from './locales/it/portfolioAnalyzer.json';
import itCreditAnalyzer from './locales/it/creditAnalyzer.json';
import itLoanPlanning from './locales/it/loanPlanning.json';
import itTaxPlanning from './locales/it/taxPlanning.json';
import itGoals from './locales/it/goals.json';
import itDocuments from './locales/it/documents.json';
import itAiAdvisor from './locales/it/aiAdvisor.json';

const resources = {
  en: {
    common: enCommon,
    feedback: enFeedback,
    glossary: enGlossary,
    financialQuestions: enFinancialQuestions,
    budget: enBudget,
    netWorth: enNetWorth,
    debtManager: enDebtManager,
    statementAnalyzer: enStatementAnalyzer,
    portfolioAnalyzer: enPortfolioAnalyzer,
    creditAnalyzer: enCreditAnalyzer,
    loanPlanning: enLoanPlanning,
    taxPlanning: enTaxPlanning,
    goals: enGoals,
    documents: enDocuments,
    aiAdvisor: enAiAdvisor,
  },
  es: {
    common: esCommon,
    financialQuestions: esFinancialQuestions,
    budget: esBudget,
    netWorth: esNetWorth,
    debtManager: esDebtManager,
    statementAnalyzer: esStatementAnalyzer,
    portfolioAnalyzer: esPortfolioAnalyzer,
    creditAnalyzer: esCreditAnalyzer,
    loanPlanning: esLoanPlanning,
    taxPlanning: esTaxPlanning,
    goals: esGoals,
    documents: esDocuments,
    aiAdvisor: esAiAdvisor,
  },
  fr: {
    common: frCommon,
    financialQuestions: frFinancialQuestions,
    budget: frBudget,
    netWorth: frNetWorth,
    debtManager: frDebtManager,
    statementAnalyzer: frStatementAnalyzer,
    portfolioAnalyzer: frPortfolioAnalyzer,
    creditAnalyzer: frCreditAnalyzer,
    loanPlanning: frLoanPlanning,
    taxPlanning: frTaxPlanning,
    goals: frGoals,
    documents: frDocuments,
    aiAdvisor: frAiAdvisor,
  },
  de: {
    common: deCommon,
    financialQuestions: deFinancialQuestions,
    budget: deBudget,
    netWorth: deNetWorth,
    debtManager: deDebtManager,
    statementAnalyzer: deStatementAnalyzer,
    portfolioAnalyzer: dePortfolioAnalyzer,
    creditAnalyzer: deCreditAnalyzer,
    loanPlanning: deLoanPlanning,
    taxPlanning: deTaxPlanning,
    goals: deGoals,
    documents: deDocuments,
    aiAdvisor: deAiAdvisor,
  },
  it: {
    common: itCommon,
    financialQuestions: itFinancialQuestions,
    budget: itBudget,
    netWorth: itNetWorth,
    debtManager: itDebtManager,
    statementAnalyzer: itStatementAnalyzer,
    portfolioAnalyzer: itPortfolioAnalyzer,
    creditAnalyzer: itCreditAnalyzer,
    loanPlanning: itLoanPlanning,
    taxPlanning: itTaxPlanning,
    goals: itGoals,
    documents: itDocuments,
    aiAdvisor: itAiAdvisor,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
